import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import historyUtils from "../../libs/history.utils";
import { useDispatch, useSelector } from "react-redux";
import { updateHQForm } from "../../actions/HQReportForm.action";
import {
  serviceGetHQReport,
  serviceGetHQReportExport,
} from "../../services/HQReport.service";

const totalShow = 50;
const useHQReport = ({}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [currentData, setCurrentData] = useState([]);
  const [inActiveData, setInActiveData] = useState([]);
  const [apiData, setApiData] = useState([]);
  const dispatch = useDispatch();
  const form = useSelector((state) => state.hq_report_form);

  useEffect(() => {
    if (form?.fy_year && form?.month && form?.quarter && form?.region_type) {
      resetData();
    }
  }, [form]);
  const resetData = useCallback(() => {
    setIsSubmitting(true);
    const commonPayload = {
      ...form,
      zone_ids: form?.zone_ids?.map((val) => val?.id) || [],
      state_ids: form?.state_ids?.map((val) => val?.id) || [],
    };

    Promise.allSettled([
      serviceGetHQReport({ ...commonPayload, status: "ACTIVE" }),
      serviceGetHQReport({ ...commonPayload, status: "INACTIVE" }),
    ])
      .then(([activeRes, inactiveRes]) => {
        if (activeRes.status === "fulfilled" && !activeRes.value?.error) {
          setCurrentData(activeRes.value.data || []);
        } else {
          console.error(
            "Error in ACTIVE API",
            activeRes.reason || activeRes.value?.error
          );
          setCurrentData([]);
        }

        if (inactiveRes.status === "fulfilled" && !inactiveRes.value?.error) {
          setInActiveData(inactiveRes.value.data || []);
        } else {
          console.error(
            "Error in INACTIVE API",
            inactiveRes.reason || inactiveRes.value?.error
          );
          setInActiveData([]);
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  }, [setIsSubmitting, form]);

  // useEffect(() => {
  //   setData(apiData);
  // }, [apiData]);

  // useEffect(() => {
  //   _processData();
  // }, [data, currentPage]);

  // const _processData = useCallback(() => {
  //   const from = currentPage * totalShow - totalShow;
  //   let to = currentPage * totalShow;
  //   if (from <= data?.length) {
  //     to = to <= data?.length ? to : data?.length;
  //     setCurrentData(data.slice(from, to));
  //   }
  // }, [setCurrentData, currentPage, data, totalShow]);

  const handleViewDetails = useCallback((data) => {
    historyUtils.push(`/employees/details/${data?.emp_code}`);
  }, []);

  const changeTextData = useCallback(
    (text, fieldName) => {
      const updatedForm = { ...form };

      if (fieldName === "fy_year") {
        updatedForm[fieldName] = text;
      } else if (fieldName === "quarter") {
        updatedForm[fieldName] = text;
        updatedForm["month"] = "";
      } else if (fieldName === "region_type") {
        updatedForm["state_ids"] = [];
        updatedForm["zone_ids"] = [];
        updatedForm[fieldName] = text;
      } else {
        updatedForm[fieldName] = text;
      }

      dispatch(updateHQForm(updatedForm));
    },
    [form, dispatch]
  );

  const overAllTotal = useMemo(() => {
    const activeTotal =
      currentData?.filter((val) => val?.type === "active_grand_total") || [];
    const inactiveTotal =
      inActiveData?.filter((val) => val?.type === "inactive_grand_total") || [];

    const total = [...activeTotal, ...inactiveTotal];

    const merged = total?.reduce(
      (acc, item) => {
        acc.manpower_count += item.manpower_count || 0;
        acc.target += item.target || 0;
        acc.achieved += item.achieved || 0;
        return acc;
      },
      { label: "Overall Total", manpower_count: 0, target: 0, achieved: 0 }
    );

    return {
      ...merged,
      achievement_pct:
        merged?.target > 0
          ? Math.round((merged?.achieved / merged?.target) * 100) + "%"
          : "0%",
    };
  }, [currentData, inActiveData]);

  const handleDownload = useCallback(() => {
    if (form?.fy_year && form?.month && form?.quarter && form?.region_type) {
      setDownloading(true);
      serviceGetHQReportExport({
        ...form,
        zone_ids: form?.zone_ids?.map((val) => val?.id) || [],
        state_ids: form?.state_ids?.map((val) => val?.id) || [],
      }).then((res) => {
        if (!res?.error) {
          const data = res?.data;
          window.open(data, "_blank");
        }
        setDownloading(false);
      });
    }
  }, [form, setDownloading]);

  return {
    currentData,
    data: apiData,
    currentPage,
    handleViewDetails,
    isSubmitting,
    form,
    changeTextData,
    inActiveData,
    overAllTotal,
    handleDownload,
    downloading,
  };
};

export default useHQReport;
